import React from 'react';
import PropTypes from 'prop-types';
import {List, ListItem} from 'material-ui/List';
import Comment from 'material-ui/svg-icons/communication/comment';
import Error from 'material-ui/svg-icons/alert/error';
import styles from './CommentModuleBlock.css';
import {white} from 'material-ui/styles/colors';
import ModuleBlock from "../ModuleBlock";
import withTranslation from "../../../../../hoc/withTranslation";
import ModuleService from "../../../../../services/module";

class CommentModuleBlock extends React.Component {
    static propTypes = {
        app: PropTypes.object.isRequired
    };

    render() {
        let content = <List>
            <ListItem
                style={styles.list}
                disabled={true}
                primaryText={this.props.t('module.comment.comment_count', {count: this.props.app.validated_comment_count || 0})}
                leftIcon={<Comment color={white}/>}/>
            <ListItem
                style={styles.list}
                disabled={true}
                primaryText={this.props.t('module.comment.to_validate_count', {count: this.props.app.unvalidated_comment_count || 0})}
                leftIcon={<Error color={white}/>}/>
        </List>;
        return (
            <ModuleBlock app={this.props.app} module={ModuleService.getModule(ModuleService.COMMENTS)} content={content}/>
        );
    }
}

export default withTranslation(CommentModuleBlock);



// WEBPACK FOOTER //
// src/components/application/ApplicationFull/ModuleBlock/CommentModuleBlock/CommentModuleBlock.js